import styled from 'styled-components/macro'

export const ResultsHeader = styled.header`
  display: flex;
  width: 100%;
  border: 0;
  border-bottom: 1px solid #ececec;
  align-items: center;
  background: transparent;
  outline: none;
  min-height: 41px;
`
